import { CLAUSE_LIBRARY, DOCUMENT_SCORECARD } from '@Constants/types';
import { scorecardsWithValidClauses } from '@Utils/jsonUtils';

const clausesMiddleware = ({ dispatch, getState }) => next => action => {
    switch (action.type) {
        case CLAUSE_LIBRARY.FETCH_LIBRARY_SUCCESS:
            const {
                payload: { flattenClauseGroups }
            } = action;
            const { scorecard } = getState().scoreCard;
            dispatch({
                type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_REQUEST
            });
            if (scorecard) {
                dispatch({
                    type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_SUCCESS,
                    payload: {
                        data: {
                            ...scorecard.data,
                            scoreCardElementList: scorecardsWithValidClauses(
                                scorecard.data.scoreCardElementList,
                                flattenClauseGroups
                            )
                        }
                    }
                });
            } else {
                dispatch({
                    type: DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_FAILURE,
                    payload: 'Scorecards are not fetched yet'
                });
            }

            return next(action);

        default:
            return next(action);
    }
};

export default clausesMiddleware;
